import {inject, Service} from '@angular/core';
import {Observable} from 'rxjs';
import {REPOSITORY_CUSTOMER_JOURNEY_TOKEN} from '../../../adapters/implementation/providers/tokens-injections';
import {CustomerJourneyRepository} from '../../ports/customer-journey/customer-journey.port';
import {CustomerJourney} from './model/customer-journey.model';
import {CustomerJourneyWithSurveyWithAssignments} from './model/customer-journey-with-survey-with-assignments.model';

/** Longueur maximale du nom d'un parcours client, imposée par l'API. */
export const CUSTOMER_JOURNEY_NAME_MAX_LENGTH = 40;

@Service()
export class CustomerJourneyService {
    private readonly customerJourneyRepository: CustomerJourneyRepository = inject(REPOSITORY_CUSTOMER_JOURNEY_TOKEN);

    public findById = (id: number): Observable<CustomerJourneyWithSurveyWithAssignments> =>
        this.customerJourneyRepository.findById(id);

    public findAll = (search?: string): Observable<CustomerJourneyWithSurveyWithAssignments[]> =>
        this.customerJourneyRepository.findAll(search);

    public create = (name: string, surveyIds: number[]): Observable<CustomerJourney> =>
        this.customerJourneyRepository.create(name, surveyIds);

    public update = (id: number, name: string, surveyIds: number[]): Observable<CustomerJourney> =>
        this.customerJourneyRepository.update(id, name, surveyIds);

    public delete = (id: number): Observable<void> => this.customerJourneyRepository.delete(id);

    /** Un parcours client porte un nom d'au plus 40 caractères et au moins une enquête. */
    public isValid = (name: string, surveyIds: number[]): boolean =>
        name.trim().length > 0 && name.trim().length <= CUSTOMER_JOURNEY_NAME_MAX_LENGTH && surveyIds.length > 0;
}
